// ── May this person see, or move, a client's money? ──────────────────
//
// ⚠️ NO MEMBER CONTEXT MEANS THE OWNER, AND THE OWNER CAN DO EVERYTHING.
// `window._appMember` is set only while a non-owner member is signed in, so
// its absence is a yes and the owner's screen is what it always was.
//
// ⚠️ NEVER `permissions[key]` DIRECTLY. The shipped Admin role holds one
// permission and it is '*'; memberHasPerm expands that and the 'area.*' form.
// Read raw, an Admin would see a screen with the buttons stripped out of it.
//
// This decides what is DRAWN. The server's own requirePermission is the lock
// (`financials.view` on client-amount-owed, `financials.charge` on
// client-retry-payment and client-charge-oneoff), so a control that slips
// through here is still refused there — the safe way for the two to disagree.

import { memberHasPerm } from '../member-permissions.js';

/** @param {string} key e.g. 'financials.view' */
export function can(key) {
  const me = /** @type {any} */ (window)._appMember;
  return !me || memberHasPerm(me.permissions, key);
}
